<template>
  <div class="p-badge-rental-flow-direction">
    <div class="flex">
      <PBadge
        v-if="flowDirection === RentalMutationFlowDirections.ISSUANCE"
        color="primary-lighten-1"
        class="border-surface border"
      >
        Uitgifte
      </PBadge>
      <PBadge
        v-else-if="flowDirection === RentalMutationFlowDirections.RETURN"
        color="secondary"
        class="border-surface border"
      >
        Retour
      </PBadge>
    </div>
  </div>
</template>

<script setup lang="ts">
import PBadge from "@/components/elements/PBadge.vue"
import { RentalMutationFlowDirections } from "@/enums/rental-mutation-flow-directions"

defineProps({
  flowDirection: {
    type: Number as () => RentalMutationFlowDirections
  }
})
</script>

<style scoped></style>
